let cart_count = document.querySelector('.header_cart_count');
let cart_drawer = document.querySelector('.header__cart__drawer');

const removeItems = (cart_items) => {
  if (cart_items) {
    cart_items?.forEach((item) => {
      let removeButton = item.querySelector('.item_delete form');
      removeButton.addEventListener('submit', (e) => {
        e.preventDefault();
        let productId = item.querySelector('[name="id"]').value;
        fetch(`/cart/change`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: productId, // The product key
            quantity: 0, // Set quantity to 0 to remove the item
          }),
        })
          .then(() => {
            refreshCart();
          })
          .catch((e) => {
            console.log('error', e);
          });
      });
    });
  }
};

const refreshCart = () => {
  let cart_count = document.querySelector('.header_cart_count');
  let cart_drawer = document.querySelector('.header__cart__drawer');
  fetch(window.location.href)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      cart_count.innerHTML = html.querySelector('.header_cart_count').innerHTML;
      cart_drawer.innerHTML = html.querySelector('.header__cart__drawer').innerHTML;

      let cartItems = document.querySelectorAll('.cart_items_wrapper .cart_items');
      removeItems(cartItems);
    });
};

document.addEventListener('cart:add', (e) => {
  refreshCart();
});
let cartItems = document.querySelectorAll('.cart_items_wrapper .cart_items');
removeItems(cartItems);
